export default __webpack_public_path__ + "static/media/reckless-icon.fb448efd.svg";